export default __webpack_public_path__ + "static/media/9.1e738e37.jpg";